<template>
    <CollapsibleWidget>
        <template #name>Master Template Resize</template>

        <Checkbox v-model="masterTemplatesLibraryStore.hideResized">Hide resized templates</Checkbox>
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import { useMasterTemplatesLibraryStore } from "@/store/pinia/masterTemplatesLibrary";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

const masterTemplatesLibraryStore = useMasterTemplatesLibraryStore();
</script>

<style lang="scss">
.editable-group {
    .show-form--showing {
        display: none;
    }
}

.editable-group__add {
    width: 100%;
}

.editable-group__values {
    width: 100%;
}
</style>
